<ng-template #confirmModalRef let-activeModal>
  <div class="modal-header justify-content-between">
    <h5 class="modal-title">{{ headerText || 'Confirmation' }}</h5>
    <button
      cpGTagEvent
      [params]="{ event_label: 'confirm_modal_dismiss' }"
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" *ngIf="!message.IsHtml">
    {{ message.Body }}
  </div>
  <div class="modal-body" *ngIf="message.IsHtml" [innerHtml]="message.Body"></div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-secondary me-2"
      cpGTagEvent
      [params]="{ event_label: 'confirm_modal_confirm' }"
      (click)="activeModal.close()">
      {{ confirmText }}
    </button>
    <button
      cpGTagEvent
      [params]="{ event_label: 'confirm_modal_cancel' }"
      type="button"
      class="btn btn-primary"
      (click)="activeModal.dismiss()">
      {{ cancelText }}
    </button>
  </div>
</ng-template>
